import { ChangeEvent, FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import devLogger from "../../../utils/devLogger";
import CustomLabel from "../../common/CustomLabel";

const ProfileSettings = () => {
  const [settingsData, setSettingsData] = useState({
    emailNotifications: "off",
    smsNotifications: "off",
    pushNotifications: "off",
  });

  const handleInputChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;

    setSettingsData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    devLogger.log(settingsData);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col justify-between flex-grow w-full h-full max-w-[calc(100%-32px)] mx-auto py-6"
    >
      <div>
        {/* <CustomLabel
          labelText="E-mail Notifications"
          labelTextClass="px-0 mb-2 text-sm font-bold"
          labelWrapClass="!gap-1 mb-4"
        >
          <select
            name="emailNotifications"
            value={settingsData.emailNotifications}
            onChange={handleInputChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value="">Select e-mail notification status</option>
            <option value="off">Off</option>
            <option value="on">On</option>
          </select>
        </CustomLabel>

        <CustomLabel
          labelText="SMS Notifications"
          labelTextClass="px-0 mb-2 text-sm font-bold"
          labelWrapClass="!gap-1 mb-4"
        >
          <select
            name="smsNotifications"
            value={settingsData.smsNotifications}
            onChange={handleInputChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value="">Select SMS notification status</option>
            <option value="off">Off</option>
            <option value="on">On</option>
          </select>
        </CustomLabel> */}

        <CustomLabel
          labelText="Push Notifications"
          labelTextClass="px-0 mb-2 text-sm font-bold"
          labelWrapClass="!gap-1 mb-4"
        >
          <select
            name="pushNotifications"
            value={settingsData.pushNotifications}
            onChange={handleInputChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-7 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value="">Select push notification status</option>
            <option value="off">Off</option>
            <option value="on">On</option>
          </select>
        </CustomLabel>
        <div className="mt-4">
          <Link
            to="/profile/request-delete"
            className="text-red-500 hover:underline"
          >
            Request account deletion
          </Link>
        </div>
      </div>

      <button
        type="submit"
        className="w-full bg-black hover:bg-gray-7 text-white font-bold py-2 px-4 rounded-[10px] focus:outline-none focus:shadow-outline"
      >
        Save
      </button>
    </form>
  );
};

export default ProfileSettings;
